export var SCHEDULES_TRANSLATIONS = {
    schedules: {
        banner: {
            requeriments: 'Requisitos básicos',
            description: 'É necessário ter o mínimo de horas para um bom resultado',
            missingHours: 'Faltam <b> {{missingHours}} horas </b> para o tempo mínimo de funcionamento',
            mediumRequeriments: 'Você está quase pronto!',
            mediumDescription: 'Está quase terminando, vamos lá, cadastre só mais algumas horas',
            successRequeriments: 'Horas mínimas prontas!',
            successDescription: 'Requisitos atendidos, você pode avançar ou registrar mais horas',
            successHours: 'Você já atingiu o <b>número mínimo de horas</b>, pode avançar!',
            tip: '<b>Dica:</b> Você pode registrar mais de {{minHours}} horas, mas este é o mínimo ideal para operar',
            hoursRegister: '{{hours}} horas',
            labelRegister: 'Horas Registradas',
        },
        listWeek: {
            days: {
                mon: 'Segunda-feira',
                tue: 'Terça-feira',
                wed: 'Quarta-feira',
                thu: 'Quinta-feira',
                fri: 'Sexta-feira',
                sat: 'Sábado',
                sun: 'Domingo',
            },
            prefixDay: {
                mon: 'S',
                tue: 'T',
                wed: 'Q',
                thu: 'Q',
                fri: 'S',
                sat: 'S',
                sun: 'D',
            },
            startTime: 'Definir horário de início',
            endTime: 'Definir horário de término',
            repetHour: 'Tempo já registrado',
            closeStore: 'Loja fechada',
            technicalError: 'Houve um problema técnico, não conseguimos salvar os horários. Tente novamente em alguns minutos',
            errorScheduleLess: 'O horário é menor que o inicial',
            replace: 'Substituir horários',
            confirm: 'Tem certeza que deseja substituir <br> os horários dos dias já cadastrados?',
            okConfirm: 'Sim, substituir',
        },
        daysWeek: {
            config: 'Configure seus horários',
            hoursSelect: 'Selecione os dias da semana em que sua loja vai funcionar',
        },
        copy: {
            copies: 'Copiar horários para...',
            clean: 'Limpiar',
            apply: 'Aplicar',
            success: 'Copiado com sucesso',
        },
        remove: {
            delete: 'Eliminar',
            success: 'Eliminado com sucesso',
            error: 'Ocorreu um problema ao excluir a programação',
            cancel: 'Cancelar',
            undo: 'Desfazer',
            confirm: 'Tem certeza de que deseja remover os horários de {{day}}? Você perderá todos os horários configurados para esse dia.',
        },
    },
};
